module.exports = __webpack_public_path__ + "assets/startpage-bf5218418f34bde8d4f3bedbe5ac5bba.png";


//////////////////
// WEBPACK FOOTER
// ./pages/Helpdesk/assets/startpage.png
// module id = 633
// module chunks = 0 1